import { SettingsForm } from '../../features/settings';

function SettingPage() {
    return <SettingsForm />;
}

export default SettingPage;
